import { Instagram, Play } from "lucide-react";
import Reveal from "./Reveal";

export default function Showcase() {
  return (
    <section id="watch" className="bg-ink py-20 text-ivory sm:py-24" data-testid="showcase-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-ivory">
            High-Quality Video Marketing
          </p>
          <h2 className="font-serif text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
            Explore an example of our video tours.
          </h2>
          <p className="mt-4 text-[15px] font-light leading-relaxed text-ivory/65 sm:text-base">
            Each property is given its own visual narrative. Working with leading real estate
            cinematographers, we create refined, cinematic films that capture the architecture,
            atmosphere and individuality of each home. Every frame is intentional—designed to reveal
            what makes the property exceptional and leave a lasting impression.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-[1.5fr_1fr]">
          <Reveal className="border border-ivory/15 bg-ink p-2 sm:p-3">
            <div className="relative aspect-video w-full overflow-hidden" data-testid="video-showcase">
              <iframe
                src="https://www.youtube-nocookie.com/embed/Ba_DNXmurs0"
                title="The Benchmark in Mineola | Luxury Home Tour in Mississauga"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
                className="absolute inset-0 h-full w-full"
              />
            </div>
            <div className="flex items-center gap-3 px-2 pb-1 pt-4 sm:px-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center bg-gold/15 text-ivory">
                <Play size={14} />
              </span>
              <div>
                <p className="text-sm font-medium text-ivory">The Benchmark in Mineola</p>
                <p className="text-[11px] uppercase tracking-[0.2em] text-ivory/50">
                  Luxury Home Tour · Mississauga
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="flex">
            <div className="flex w-full flex-col justify-between border border-ivory/15 bg-ivory/[0.04] p-8 sm:p-10">
              <div>
                <span className="flex h-12 w-12 items-center justify-center border border-gold text-ivory">
                  <Instagram size={20} />
                </span>
                <h3 className="mt-6 font-serif text-2xl sm:text-3xl" data-testid="instagram-handle">
                  @willfrenchrealestate
                </h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-ivory/65">
                  Behind-the-scenes tours, new listings before they hit the market, and life on the
                  water — follow along on Instagram.
                </p>
              </div>
              <a
                href="https://www.instagram.com/willfrenchrealestate/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-follow-btn"
                className="mt-8 flex w-fit items-center gap-2 border border-ivory px-6 py-3.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory transition-colors hover:bg-ivory hover:text-ink"
              >
                <Instagram size={14} />
                Follow @willfrenchrealestate
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}